import React from 'react';
import { FormStateContext } from '@/contexts/FormStateContext';
import { filterDuplicateDocuments } from '@utils/usefulFuncs';

/**
 * Bridges the legacy, props-driven document selection components to FormStateContext.
 * Returns the current selection plus add/remove handlers that mirror the dedupe
 * semantics used by FilteredDocumentsSelection, so adapted modes behave identically
 * to the natively context-driven ones (company / myDocs).
 */
export const useSelectedDocs = () => {
  const { state, setFormStateValue } = React.useContext(FormStateContext);
  const selectedDocs = state.selectedDocs;

  const onChange = React.useCallback((value) => setFormStateValue('selectedDocs', value), [setFormStateValue]);

  const onAddDocument = React.useCallback(
    (document) => {
      const additions = Array.isArray(document) ? document : [document];
      onChange(filterDuplicateDocuments([...selectedDocs, ...additions]));
    },
    [onChange, selectedDocs]
  );

  const onRemoveDocument = React.useCallback(
    (document) => {
      const removals = Array.isArray(document) ? document : [document];
      const removeIds = removals.map((d) => d.id);
      onChange(selectedDocs.filter((d) => !removeIds.includes(d.id)));
    },
    [onChange, selectedDocs]
  );

  return { selectedDocs, onAddDocument, onRemoveDocument };
};
